import barSimpleBarChart from "assets/images/chart-images/simple-chart.png";
import table from "assets/images/chart-images/table.png";
import barHorizontalBarChart from "assets/images/chart-images/horizontal-bar-chart.png";
// import mapWorldMap from "assets/images/chart-images/map/map_world_map.png";

const countriesList = [
        { id: "%RIsPCqc-BV01p", name: "simple-bar", chartImage: barSimpleBarChart, disabled: false },
        { id: "%RIsPCqc-BH01p", name: "horizontal-bar", chartImage: barHorizontalBarChart, disabled: false },
        { id: "%RIsPCqc-T01p", name: "table", chartImage: table, v2: "Column", disabled: false },
        { id: "%RIsPCqc-T02p", name: "table", chartImage: table, v2: "Row", disabled: false },
];

export default countriesList;

